export type LibraryKind = "all" | "apps" | "pages" | "slides" | "sites" | "images";
export function libraryKind(item: {
  name: string;
  mimeType: string;
  isApp?: boolean;
}): Exclude<LibraryKind, "all"> | "other" {
  if (item.isApp) return "apps";
  const mime = item.mimeType.split(";")[0]!.toLowerCase();
  const ext = item.name.toLowerCase().split(".").at(-1);
  if (mime.startsWith("image/")) return "images";
  if (
    mime.includes("presentation") ||
    mime.includes("powerpoint") ||
    ["ppt", "pptx", "odp"].includes(ext ?? "")
  )
    return "slides";
  if (mime === "text/html" || ["html", "htm"].includes(ext ?? "")) return "sites";
  if (
    mime.startsWith("text/") ||
    mime === "application/pdf" ||
    mime.includes("wordprocessingml") ||
    mime === "application/msword" ||
    ["md", "txt", "pdf", "doc", "docx", "rtf"].includes(ext ?? "")
  )
    return "pages";
  return "other";
}
